<p
  class="inline-loading"
  [class.inline-loading--centered]="centered()"
  [class.inline-loading--stacked]="stacked()"
  role="status"
  aria-live="polite"
>
  <span class="inline-loading__spinner" aria-hidden="true"></span>
  <span class="inline-loading__text">{{ label() }}</span>
</p>
